<template>
<td v-bind="$attrs" style="text-align: center" @mouseleave="onCellFocusOut">
  <div>
    <button class="my-button" @click="onClickAction" ref="button">{{ buttonName }}</button>
  </div>
</td>

</template>
<script>
import { i18n } from '@/i18n'

export default {
  inheritAttrs: false,
  components: {
  },
  data () {
    return {
      show: false,
      mouseOverPopup: false,
      buttonName: i18n.t('app.detail')
    }
  },
  mounted: function () {
    this.show = false
  },
  props: {
    dataItem: Object
  },
  methods: {
    onClick (e) {
      this.show = true
    },
    onClickAction (e) {
      this.$emit('actionselect', { dataItem: this.dataItem, action: e.target.id })
      this.show = !this.show
    },
    onFocusOut (e) {
      this.show = false
      this.mouseOverPopup = false
    },
    onCellFocusOut (e) {
      setTimeout(() => {
        if (!this.mouseOverPopup) {
          this.show = false
        }
        this.mouseOverPopup = false
      })
    },
    onMouseEnter () {
      this.mouseOverPopup = true
    }
  }
}
</script>

<style scoped>
    .my-button {
        border-radius: 18px;
        background-color: transparent;
        color: var(--primary-DEFAULT);
    }

    .action {
        margin: 10px 20px 10px 20px;
        cursor: pointer
    }
</style>
